import React from 'react';
import { motion } from 'framer-motion';

export const BrandLoader: React.FC = () => {
  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-50">
      <motion.div
        animate={{
          scale: [1, 1.1, 1],
          opacity: [0.7, 1, 0.7],
        }}
        transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: "easeInOut"
        }}
        className="flex flex-col items-center justify-center"
      >
        <img 
          src="/Group 21.png" 
          alt="Artist Network International Loading" 
          className="w-32 h-32 object-contain"
        />
        <p className="mt-4 text-gray-500 font-medium tracking-wide">Loading ANI...</p>
      </motion.div>
    </div>
  );
};
